import { FC } from "react"
import { SubCaste } from "../../../../domain/entities/subCaste"
import { BlankStateSection } from "../../../shared/BlankStateSection"
import { CenteredSpinner } from "../../../shared/CenteredSpinner"
import { SubCasteListView } from "./SubCasteListView"

interface Props {
	list: SubCaste[]
	isLoading: boolean
	onUpdate: (subCaste: SubCaste) => void
	onDelete: (subCaste: SubCaste) => void
	onAddClick: () => void
}

export const SubCasteListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return (
			<BlankStateSection message="No Sub Castes found." onAddClick={onAddClick} />
		)
	}

	return <SubCasteListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
